export var capitalize = function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

var getCustomStyles = function getCustomStyles(styles) {
  if (styles) {
    var splitStyles = styles.split(';');
    var styleObj = {};

    for (var i = 0; i < splitStyles.length - 1; i++) {
      var key = splitStyles[i].split(':')[0].trim();
      var val = splitStyles[i].split(':')[1].trim();

      if (key.indexOf('-') > -1) {
        key = key.split('-');
        key = key[0] + capitalize(key[1]);
      }

      styleObj[key] = val;
    }

    return styleObj;
  }

  return {};
};

export default getCustomStyles;